import React, { useState, useEffect } from "react";
import { createWord, updateWord } from "./adminSimilarWordsService";
import "../../styles/content.css";

const WordForm = ({ word, wordGroupId, onSaved, onCancel }) => {
  const isEdit = !!word;
  const [form, setForm] = useState({
    word: "", pronunciation: "", phoneticSpelling: "", meaning: "", examples: "",
    isActive: true, displayOrder: 1,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (word) {
      console.log("[WordForm] Populating for edit, id:", word.id);
      setForm({
        word: word.word || "", pronunciation: word.pronunciation || "",
        phoneticSpelling: word.phoneticSpelling || "",
        meaning: word.meaning || "", examples: word.examples || "",
        isActive: word.isActive !== false, displayOrder: word.displayOrder || 1,
      });
    }
  }, [word]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async () => {
    if (!form.word || !form.meaning) { alert("Word and Meaning are required"); return; }
    const payload = { ...form, wordGroupId, displayOrder: Number(form.displayOrder) || 1 };
    console.log("[WordForm] Submitting", isEdit ? "update" : "create", "payload:", payload);
    setLoading(true);
    const res = isEdit ? await updateWord(word.id, payload) : await createWord(payload);
    if (res.status === 200 || res.status === 201) { console.log("[WordForm] Success:", res.status); onSaved(); }
    else { console.error("[WordForm] Failed:", res.status, res.message); alert(res.message || "Operation failed"); }
    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: 520, maxHeight: "90vh", overflowY: "auto" }}>
        <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
          <h2>{isEdit ? "Edit" : "Add"} Word</h2>
          <div className="form-group"><label>Word *</label><input name="word" placeholder="e.g. Break" value={form.word} onChange={handleChange} /></div>
          <div className="form-group"><label>Pronunciation (IPA)</label><input name="pronunciation" placeholder="/breɪk/" value={form.pronunciation} onChange={handleChange} /></div>
          <div className="form-group"><label>Phonetic Spelling</label><input name="phoneticSpelling" placeholder="e.g. brayk" value={form.phoneticSpelling} onChange={handleChange} /></div>
          <div className="form-group"><label>Meaning *</label><textarea name="meaning" placeholder="To separate into pieces; to pause or rest" value={form.meaning} onChange={handleChange} rows={2} /></div>
          <div className="form-group"><label>Examples</label><textarea name="examples" placeholder="Let's take a break from studying. The glass will break if you drop it." value={form.examples} onChange={handleChange} rows={3} /></div>
          <div className="form-group"><label>Display Order</label><input name="displayOrder" type="number" min="1" value={form.displayOrder} onChange={handleChange} /></div>
          <div className="form-group"><label style={{ display: "flex", alignItems: "center", gap: 8 }}><input name="isActive" type="checkbox" checked={form.isActive} onChange={handleChange} /> Active</label></div>
          <div className="form-actions"><button onClick={handleSubmit} disabled={loading}>{loading ? "Saving..." : isEdit ? "Update" : "Add"}</button><button onClick={onCancel} disabled={loading}>Cancel</button></div>
        </div>
      </div>
    </div>
  );
};

export default WordForm;
